import { Expose } from 'class-transformer';
import { CalloutContent } from './callout-content.entity';

export class DialogContent extends CalloutContent {
  @Expose()
  confirmButtonText?: string;
  @Expose()
  cancelButtonText?: string;
  @Expose()
  okButtonText?: string;
}
